export function normalice(number) {
    if (number >= 10) return number;
    else return '0' + number;
}

export function formatDate(inputDate) {
    let formatted_date = inputDate.getFullYear() + '-' + normalice(inputDate.getMonth() + 1) + '-' + normalice(inputDate.getDate());
    return formatted_date;
}
